function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_10996",
  "data-name": "Group 10996",
  transform: "translate(1.473 1.473)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_465",
  "data-name": "Line 465",
  x1: 0.919,
  y2: 21.801,
  transform: "translate(15.416 0) rotate(45)",
  stroke: "#E25555",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_466",
  "data-name": "Line 466",
  x1: 0.919,
  y1: 21.801,
  transform: "translate(16.066 15.416) rotate(135)",
  stroke: "#E25555",
  strokeLinecap: "round",
  strokeWidth: 3
}));
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 19.011 19.011",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloseIcon.ac1c5ce6.svg";
export { ForwardRef as ReactComponent };